import React from 'react';

import { observer } from 'mobx-react';

import classes from './SolutionItem.module.scss';
import { solutionsStore } from '../../../../stores/solutionsStore';
import { NAVIGATION_ICON } from '../../../../constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../../../../constants/user-info/solutionType';
import { getNavigationIcon } from '../../../../utils/navigationUtils/getNavigationIcon/getNavigationIcon';
import { getHumanizeSolutionType } from '../../../../utils/userInfoUtils/getHumanizeSolutionType/getHumanizeSolutionType';

const solutionIconsMap = {
  [SOLUTION_TYPE.NUTRITION]: NAVIGATION_ICON.NUTRITION_CHIP,
  [SOLUTION_TYPE.SCAN_IQ]: NAVIGATION_ICON.SCAN_IQ_CHIP,
  [SOLUTION_TYPE.CHALLENGE]: NAVIGATION_ICON.CHALLENGE_CHIP,
};

const SolutionItem = observer(() => {
  const { activeSolution } = solutionsStore;

  if (!activeSolution) {
    return null;
  }

  return (
    <div className={classes.container}>
      {getNavigationIcon(solutionIconsMap[activeSolution])}
      <p>{getHumanizeSolutionType(activeSolution)}</p>
    </div>
  );
});

export { SolutionItem };
